module.exports = __webpack_public_path__ + "media/Office_IN.11eced65.mp4";